/* eslint consistent-return: 0 */
import { useState, useLayoutEffect, useRef, useMemo, useEffect } from "react";
export function useForceUpdate() {
  const [state, setState] = useState(false);
  return [state, function forceUpdate() {
    setState(state => !state);
  }];
}
export function useIntersectionObserver(options) {
  const ref = useRef();
  const [inView, setInView] = useState(false);
  const observer = useMemo(() => new IntersectionObserver(_ref => {
    let [{
      isIntersecting
    }] = _ref;
    return setInView(isIntersecting);
  }, options), []);
  useLayoutEffect(() => {
    observer.observe(ref.current);
    return () => observer.unobserve(ref.current);
  });
  return {
    ref,
    inView
  };
}
let id = 0;
export const useId = () => useState(() => ++id)[0];
export function useEventListener(target, event, listener) {
  let deps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  useLayoutEffect(() => {
    if (!listener || !target) return;
    target.addEventListener(event, listener);
    return () => {
      target.removeEventListener(event, listener);
    };
  }, [target, ...deps]);
}
export function useAutoId(id) {
  let prefixId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  const generatedId = useId();
  return id || `${prefixId}-${generatedId}`;
}
export function useOnResize(callback) {
  useEffect(() => {
    window.addEventListener("resize", callback);
    return () => window.removeEventListener("resize", callback);
  }, [callback]);
}
export function useIsMounted() {
  const isMounted = useRef(false);
  const [, forceUpdate] = useForceUpdate();
  useLayoutEffect(() => {
    isMounted.current = true;
    forceUpdate();
    return () => {
      isMounted.current = false;
    };
  }, []);
  return () => isMounted.current;
}
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    function onChange(ev) {
      setMatches(ev.matches);
    }
    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener("change", onChange);
    } else {
      mediaQueryList.addListener(onChange);
    }
    return () => {
      if (mediaQueryList.removeEventListener) {
        mediaQueryList.removeEventListener("change", onChange);
      } else {
        mediaQueryList.removeListener(onChange);
      }
    };
  }, [query]);
  return matches;
}
export function useIsMobile() {
  const MOBILE_BREAKPOINT = 768;
  const isMobile = useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT}px)`);
  return isMobile;
}
export function useStateToRef(state) {
  const ref = useRef(state);
  useEffect(() => {
    ref.current = state;
  }, [state]);
  return ref;
}
//# sourceMappingURL=hooks.js.map